import { pxToRem } from '../../utils';
var popupContentStyles = {
    root: function (_a) {
        var props = _a.props, variables = _a.variables;
        var backgroundColor = variables.backgroundColor, borderColor = variables.borderColor, padding = variables.padding;
        return {
            display: 'block',
            backgroundColor: backgroundColor,
            padding: padding,
            border: "1px solid " + borderColor,
            borderRadius: pxToRem(3),
            boxShadow: "0 2px 4px 0 " + borderColor + ", 0 2px 10px 0 " + borderColor,
        };
    },
};
export default popupContentStyles;
